<template>
    <div class="learningProducts">
        <full-page :options="options2" ref="fullpage">
            <div class="section one">
                <h3>
                    <div class="one-text">智能健身房一体化解决方案</div>
                    <div class="one-text1">智能硬件+大数据+健身房管家
                        <br>全方位提升用户体验
                    </div>
                    <div class="one-text2"><span style="font-size: 0.7vw;">Tel: </span> 0351-2379580</div>
                </h3>
                <!-- <p>为你精准推荐健身计划，助你更快达成健身目的</p> -->
                <img src="../assets//image/indexl1.png" alt="" class="one-img">
            </div>

            <div class="section two">
                <h3>软件硬件无缝衔接——健身房管理智能化方案供应商</h3>
                <p class="p">
                    打造线上线下智能化健身房系统
                </p>
                <div class="tow-box">
                    <el-row :gutter="40">
                        <el-col :span="6">
                            <div class="tow-item">
                                <img src="../assets/image/iconl1.png" alt="">
                                <div>智能身份识别系统</div>
                            </div>
                        </el-col>
                        <el-col :span="6">
                            <div class="tow-item">
                                <img src="../assets/image/iconl2.png" alt="">
                                <div>智能化场馆设施</div>
                            </div>

                        </el-col>
                        <el-col :span="6">
                            <div class="tow-item">
                                <img src="../assets/image/iconl3.png" alt="">
                                <div>运动数据采集</div>
                            </div>

                        </el-col>
                        <el-col :span="6">
                            <div class="tow-item">
                                <img src="../assets/image/iconl4.png" alt="">
                                <div>会员健康报告</div>
                            </div>

                        </el-col>
                    </el-row>
                </div>
            </div>
            <div class="section five">
                <h3>智能身份识别系统</h3>
                <p class="p">智能化人脸识别闸机，秒级的人脸识别速度，出入人员无需任何接触就<br>
                    可以快速通过，无需手动减课消次。自动统计数据，形成入场数据报告。<br>
                    智能私教课程验证设备，用户扫脸签到、签退便可核销课程。<br>
                    智能储物柜，人脸识别实现开柜存取服务，方便快捷。</p>
                <img class="fRight" src="../assets/image/indexl2.png" alt="">
            </div>
            <FooterVue class="section"></FooterVue>
        </full-page>
    </div>
</template>
  
<script setup>
// location.reload()
import { reactive, ref, defineEmits } from 'vue';
import FooterVue from '../components/FooterVue.vue';
const changeColor = defineEmits(['changeColor']);
changeColor('changeColor', '')

const fullpage = ref()
const options2 = {
    licenseKey: "OPEN-SOURCE-GPLV3-LICENSE",
    anchors: ['one', 'two', 'three', 'four', 'five'],
    // menu: '#menu',
    lockAnchors: true,
    navigation: false,//显示导航
    navigationPosition: 'right',
    verticalCentered: false,
    onLeave: (index, nextIndex) => {
        if (nextIndex.index === 0 || nextIndex.index === 2 || nextIndex.index === 3) {
            changeColor('changeColor', '')
        } else {
            changeColor('changeColor', true)
        }
    },
    afterRender: () => {
        setTimeout(() => {
            fullpage.value.api.moveTo(1, 0);
        }, 200)
    }
}
</script>
  
<style lang="scss">
@import '@/assets/css/style.css';

.learningProducts {
    .fp-overflow {
        height: 100%;
    }

    .one-footer {
        position: inherit;
    }

    .section {
        height: 100%;
    }

    .one {
        background: url(../assets/image/bannerl1.png) no-repeat;
        background-size: 100% auto;
        position: relative;

        .one-img {
            position: absolute;
            bottom: 65px;
            right: 136px;
            height: 80%;
        }

        .phone {
            position: absolute;
            height: 60%;
            top: 24%;
            left: 25%;
        }

        .xiahua {
            position: absolute;
            height: 42px;
            bottom: 10%;
            right: 8%;
        }

        h3 {
            color: #fff;
            font-size: 48px;
            position: absolute;
            left: 8%;
            top: 23%;
            font-weight: 500;
            text-align: left;

            .one-text {
                font-size: 4.48vw;
                margin: 0;
                font-family: AlibabaPuHuiTi-Regular, AlibabaPuHuiTi, AlibabaPuHuiTi;
                font-weight: 400;
                color: #FFFFFF;
            }

            .one-text1 {
                font-size: 2.29vw;
                font-family: AlibabaPuHuiTi-Light, AlibabaPuHuiTi, AlibabaPuHuiTi;
                font-weight: 300;
                color: #FFFFFF;
                margin: 1.87vw auto 4.6vw;
            }

            .one-text2 {
                font-size: 1.14vw;
                font-family: AlibabaPuHuiTi-Bold
            }

            .more {
                width: 11.45vw;
                height: 3.12vw;
                background: #E50A33;
                border-radius: 30px 30px 30px 30px;
                opacity: 1;
                font-size: 1.45vw;
                font-family: SourceHanSansCN-Regular, SourceHanSansCN, SourceHanSansCN;
                font-weight: 400;
                color: #FFFFFF;
                display: inline-block;
                box-sizing: border-box;
                line-height: 3vw;
            }

            img {
                position: absolute;
                left: 0;
                top: -60px;
                width: 200px;
            }
        }

        p {
            color: #fff;
            font-size: 24px;
            position: absolute;
            left: 50%;
            top: 53%;
            opacity: .5;
            width: 384px;
            font-weight: 200;
            line-height: 40px;
        }
    }

    .two { 
        background-color: #FFFFFF;
        z-index: 99;

        .tow-box {
            width: calc(100% - 360px);

            position: absolute;
            left: 0;
            right: 0;
            bottom: 10%;
            margin: auto;

            .tow-item {
                height: 100%;
                box-sizing: border-box;
                padding: 25% 0;
                display: flex;
                align-items: center;
                flex-direction: column;
                justify-content: center;
                box-shadow: 10px 0px 50px 0px #DFDFDF;
                border-radius: 20px;

                img {
                    width: 127px;
                    height: 124px;
                    margin-bottom: 50px;
                }

                div {
                    font-size: 1.8vw;
                    font-family: AlibabaPuHuiTi-Regular, AlibabaPuHuiTi;
                    font-weight: 400;
                    color: #333333;
                    line-height: 36px;
                }
            }
        }

        h3 {
            font-size: 3vw;
            font-family: AlibabaPuHuiTi-Medium, AlibabaPuHuiTi, AlibabaPuHuiTi;
            font-weight: 500;
            color: #000000;
            text-align: left;
            z-index: 1;
            width: calc(100% - 360px);
            margin: 160px auto 0;
        }

        h3::before {
            width: 2.5vw;
            height: 2.5vw;
            content: "";
            position: absolute;
            border: 10px solid #E50A33;
            border-radius: 50%;
            margin-top: -1vw;
            margin-left: -1.8vw;
            z-index: -1;
        }

        .p {
            font-size: 1.14vw;
            font-family: AlibabaPuHuiTi-Light;
            font-weight: 400;
            color: #333333;
            width: calc(100% - 360px);
            margin: 30px auto 0;
        }
    }

    .five {
        overflow: hidden;
        position: relative;
        background: url(../assets/image/bannerl2.png) no-repeat;
        background-size: auto 100%;

        .fRight {
            position: absolute;
            right: 15vw;
            top: 0;
            bottom: 0;
            margin: auto;
            height: 50%;
        }

        h3 {
            font-size: 3vw;
            font-family: AlibabaPuHuiTi-Medium, AlibabaPuHuiTi;
            font-weight: 500;
            color: #FFFFFF;
            position: absolute;
            top: 30%;
            left: 10%;
            z-index: 9;
            position: relative;
            z-index: 1;
            width: 50%;
        }
        h3::after {
            width: 2.5vw;
            height: 2.5vw;
            content: "";
            position: absolute;
            border: 10px solid #E50A33;
            border-radius: 50%;
            margin-top: -1vw;
            margin-left: -1.8vw;
            z-index: -1;
        }
        .p {
            font-size: 1.14vw;
            font-family: AlibabaPuHuiTi-Light;
            font-weight: 400;
            color: #FFFFFF;
            position: absolute;
            z-index: 9;
            left: 10%;
            margin-top: 49px;
            line-height:40px;
            top: 45%;
        }
    }

    .six {
        background: linear-gradient(181deg, #F8F8F8 0%, #F7F7F7 100%);
        z-index: 99;

        .phone {
            position: absolute;
            height: 70%;
            top: 16%;
            left: 22%;
        }

        h4 {
            font-size: 45px;
            position: absolute;
            left: 48%;
            top: 30%;
            font-weight: 600;

            >div {
                position: relative;
                z-index: 9;
            }

            span {
                position: absolute;
                left: 0;
                bottom: -6px;
                width: 90px;
                height: 20px;
                background: linear-gradient(180deg, rgba(238, 20, 74, 0.1) 0%, rgba(234, 20, 53, 0.43) 54%, rgba(248, 39, 75, 0.79) 100%);
            }
        }

        p {
            color: #fff;
            font-size: 21px;
            position: absolute;
            left: 27%;
            top: 62%;
            opacity: .5;
            width: 384px;
            font-weight: 200;
            line-height: 40px;
        }
    }
}
</style>
  